export default "{\n    \"label\": \"Tipo de equipo\",\n    \"placeholder\": \"Seleccione tipo de equipo\"\n}"